var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('h1',[_vm._v("利用中です")]),_c('button',{staticClass:"btn btn-danger btn-lg",staticStyle:{"width":"160px","height":"50px","font-size":"15px"},attrs:{"id":"logout"},on:{"click":_vm.logout}},[_vm._v("再入室")])])}
var staticRenderFns = []

export { render, staticRenderFns }